export default "__VITE_ASSET__DBoOOxWX__"